import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import Ftm2024Page from './pages/Ftm2024Page';
import Ftm2019Page from './pages/Ftm2019Page';
import AncestrySupportPage from './pages/AncestrySupportPage';
import SupportPage from './pages/SupportPage';
import BlogsPage from './pages/BlogsPage';
import ArticlePage from './pages/ArticlePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsPage from './pages/TermsPage';
import RefundPolicy from './pages/RefundPolicy';
import DisclaimerPage from './pages/DisclaimerPage';
import NotFound from './pages/NotFound';
import { findArticle } from './constants/articles';
import { BRAND_NAME, SITE_DOMAIN } from './constants/site';

const PAGE_TITLES = {
  '/': `${BRAND_NAME} | Independent FTM Support`,
  '/about-us': `About Us | ${BRAND_NAME}`,
  '/contact-us': `Contact Us | ${BRAND_NAME}`,
  '/faqs': `FAQs | ${BRAND_NAME}`,
  '/family-tree-maker-2024': `Family Tree Maker 2024 Help | ${BRAND_NAME}`,
  '/family-tree-maker-2019': `Family Tree Maker 2019 Help | ${BRAND_NAME}`,
  '/ancestry-support': `Ancestry, FamilySearch & TreeVault Help | ${BRAND_NAME}`,
  '/support': `Support Center | ${BRAND_NAME}`,
  '/blogs': `Help Guides | ${BRAND_NAME}`,
  '/privacy-policy': `Privacy Policy | ${SITE_DOMAIN}`,
  '/terms-and-conditions': `Terms & Conditions | ${SITE_DOMAIN}`,
  '/refund-policy': `Refund Policy | ${SITE_DOMAIN}`,
  '/disclaimer': `Disclaimer | ${SITE_DOMAIN}`,
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const article = pathname.startsWith('/blog/') && findArticle(pathname.slice(6));
    document.title = article
      ? `${article.title} | ${BRAND_NAME}`
      : PAGE_TITLES[pathname] || PAGE_TITLES['/'];
  }, [pathname]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about-us" element={<AboutPage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/faqs" element={<FaqPage />} />
        <Route path="/family-tree-maker-2024" element={<Ftm2024Page />} />
        <Route path="/family-tree-maker-2019" element={<Ftm2019Page />} />
        <Route path="/ancestry-support" element={<AncestrySupportPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blog/:slug" element={<ArticlePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsPage />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
